import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type featureOptionClasses =
  | 'container'
  | 'gridContainer'
  | 'itemContainer'
  | 'selectedFeatureContainer'
  | 'option'
  | 'image'
  | 'imageUnavailable'
  | 'metaContainer'
  | 'name'
  | 'additionalInfoContainer'
  | 'withoutBorder'
  | 'selectionContainer'
  | 'priceText'
  | 'moreDetailsToggle'
  | 'itemContainerDisabled'
  | 'backdrop';

const featureOptionStyle = makeStyles<ISpcTheme, featureOptionClasses>(
  ({ palette, typography, breakpoints }) => ({
    container: {
      padding: '15px 0 0',
    },
    gridContainer: {
      marginBottom: '20px',
      padding: '10px 10px 0',
      cursor: 'pointer',
      position: 'relative',
    },
    itemContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    selectedFeatureContainer: {
      border: `1px solid ${palette.primary.main}`,
    },
    image: {},
    option: {},
    imageUnavailable: {
      width: '100%',
      height: 'auto',
    },
    metaContainer: {
      padding: '10px 0 20px',
      [breakpoints.down('sm')]: {
        padding: '10px 0 10px',
      },
    },
    name: {
      color: palette.text.primary,
      fontWeight: typography.fontWeightBold,
      fontSize: typography.fontSM,
      wordBreak: 'break-word',
      [breakpoints.down('sm')]: {
        fontSize: typography.fontXS,
      },
    },
    additionalInfoContainer: {
      alignItems: 'center',
      borderBottom: `1px solid rgba(0,0,0,.2)`,
      borderTop: `1px solid rgba(0,0,0,.2)`,
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 'auto',
    },
    selectionContainer: {
      borderBottom: 0,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    withoutBorder: {
      borderBottom: 0,
    },
    priceText: {
      color: palette.text.primary,
      fontSize: typography.fontSM,
      lineHeight: 'initial',
      [breakpoints.down('sm')]: {
        fontSize: typography.fontXXS,
      },
    },
    moreDetailsToggle: {
      color: palette.primary.main,
    },
    itemContainerDisabled: {
      pointerEvents: 'none',
    },
    backdrop: {
      position: 'absolute',
      background: `repeating-linear-gradient(
        -45deg,
        ${palette.grey[400]},
        ${palette.grey[400]} 10px,
        ${palette.grey[900]} 10px,
        ${palette.grey[900]} 20px
      )`,
      width: 'calc(100% - 15px)',
      height: 'calc(100% - 15px)',
      opacity: 0.05,
      zIndex: 1,
      cursor: 'not-allowed',
      borderRadius: 'inherit',
    },
  }),
  { name: 'Customise_Feature_Option' },
);

export default featureOptionStyle;
